import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/overlay/overlay.component.js'

const tagName = 'dap-ds-overlay'

/**
 * `dap-ds-overlay`
 * @summary An overlay is a container for overlay content.
 * @element dap-ds-overlay
 * @title - Overlay
 *
 * @csspart overlay - The overlay element
 *
 * @cssproperty --dds-overlay-z-index - Controls the z-index of the overlay (default: 1)
 * @cssproperty --dds-overlay-background-color - Controls the background color of the overlay (default: var(--dds-black-10))
 * @cssproperty --dds-overlay-opacity-closed - Controls the opacity when overlay is closed (default: 0)
 * @cssproperty --dds-overlay-opacity-open - Controls the opacity when overlay is open (default: 1)
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSOverlay',
})

export default reactWrapper
